import React from "react";
import { Route, Routes } from "react-router-dom";
import NotFound404 from "../../pages/error/NotFound404";
import DispenserDashboard from "../../pages/dashboard/DispenserDashboard";

const DispenserRoutes = () => {
  return (
    <Routes>
      <Route path="/dashboard" element={<DispenserDashboard />} />
      <Route path="/*" element={<NotFound404 />} />
    </Routes>
  );
};

export default DispenserRoutes;
